(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('SearchInvoicesListController', SearchInvoicesListController);

SearchInvoicesListController.$inject = ['$filter', '$state', '$stateParams', '$sce', 'InvoicesService', 'ExpoService', 'SellerService', 'CompaniesService'];

    function SearchInvoicesListController($filter, $state, $stateParams, $sce, InvoicesService, ExpoService, SellerService, CompaniesService) {
        var vm = this;

        vm.invoices;

        vm.name;
        vm.email;
        vm.control_id;
        vm.invoice_id;
        vm.dueDate = {startDate: null, endDate: null};
        vm.dispatchDate = {startDate: null, endDate: null};
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.getInvoiceStatusLabel = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass = getInvoiceStatusClass;
        vm.remove                = remove;   
        vm.sendToCustomer        = sendToCustomer;
        vm.sendToSeller          = sendToSeller;
        vm.invoiceStatus         = [{id : -1, name : '--- All ---'}, {id : 1, name : 'Paid'}, {id : 0, name : 'Not paid (All)'}, {id : 2, name : 'Not paid (Overdue)'}];
        vm.invoiceStatusSelected = {id : -1, name : '--- All ---'};
        vm.invoiceTypesSelected  = [];

        vm.selectOptionAll = [{
            name: '--- All ---'
        }];

        vm.sellers              = [];
        vm.sellerSelected;
        vm.loadSellers          = loadSellers;

        vm.expos                = [];
        vm.expoSelected;
        vm.loadExpos            = loadExpos;  

        vm.virtualFairs         = [];
        vm.virtualFairSelected;
        vm.loadVirtualFairs     = loadVirtualFairs;   

        vm.loadCompanies        = loadCompanies;
        vm.companies            = null;
        vm.companySelected      = -1;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;        

        vm.getByFilter    = getByFilter;   
        vm.downloadCSV    = downloadCSV;   

        vm.syncQBO        = syncQBO;

        vm.loadSemesters = loadSemesters;
        vm.semesters     = [{id : '', name : '--- All ---'}];
        vm.semesterSelected;

        vm.clearFilters = true;
        vm.changeOrder = changeOrder;
        vm.orderByTotal = 'total_asc';

        vm.message = null;
        vm.classMessage = null;

        activate();

        function activate() {
            
            if ($stateParams.hasOwnProperty('control_id') && $stateParams.control_id != undefined) {
                vm.control_id = $stateParams.control_id;
                vm.getByFilter();
            }   

            if ($stateParams.hasOwnProperty('invoice_created') && $stateParams.invoice_created != undefined) {
                vm.invoice_id = $stateParams.invoice_created;
                vm.getByFilter();
            }       

            loadSellers();
            loadExpos();
            loadVirtualFairs();
            loadSemesters();
            getInvoiceTypes(); 
            loadCompanies();
        }

        function loadExpos() {

            var query = {};
            if (vm.semesterSelected && vm.semesterSelected.id != '') {
                query['semester'] = vm.semesterSelected.id;
            }

            ExpoService.getExposForSelect(query).then(function(response) {
                vm.expos = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function getInvoiceTypes() {
            InvoicesService.getInvoiceTypes().then(function(response) {
                vm.invoiceTypes = response.data;
            }).catch(function(err) {
            });
        }

        function loadVirtualFairs() {
            ExpoService.getExposVirtualFair().then(function(response){
                vm.virtualFairs = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }     

        function loadSellers() {            
            SellerService.getAll().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });          
        }    

        function loadSemesters() {
            ExpoService.getSemesters().then(function (response) {
                angular.forEach(response.data, function(value) {
                    this.push({id : value.semester, name : value.semester });
                }, vm.semesters);
            });
        }  

        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };

        function getInvoiceStatusLabel(status, due_date) {
            if (status === 'paid')
                return 'Paid';
            else { 
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)               
                    return 'Overdue';   
            }
            
            return 'Waiting Payment';
            
        }

        function syncQBO(invoice){
            InvoicesService.qboSync(invoice.id).then(function(response){
            }).catch(function(err) {
            });
        }


        function getInvoiceStatusClass(status, due_date) {
            if (status === 'paid')
                return 'label-success';
            else {
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)
                    return 'label-danger';                
            }

            return 'label-warning';
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    InvoicesService.destroy(invoice.id).then(function() {
                        vm.invoices.splice(vm.invoices.indexOf(invoice), 1);
                        alertify.notify('Invoice removed', 'success', 3);
                    });
                })
                .show();
        }

        function sendToCustomer(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.contact_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToCustomer(invoice.id).then(function() {                        
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }

        function sendToSeller(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.seller_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToSeller(invoice.id).then(function() {                        
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }

        function getByFilter(flag = true) {
            console.log(flag);
            if (flag) {
                vm.query = {};   
            }
            
            vm.query['page'] = vm.page;            

            if (vm.name) {
                vm.query['company_name'] = vm.name;
            }

            if (vm.email) {
                vm.query['company_email'] = vm.email;
            }

            if (vm.invoice_id) {
                vm.query['invoice_id'] = vm.invoice_id;
            }

            if (vm.control_id) {
                vm.query['control_id'] = vm.control_id;
            }

            if (vm.sellerSelected) {
                vm.query['seller_id'] = vm.sellerSelected.id;
            }

            if (vm.expoSelected) {
                vm.query['expo_id'] = vm.expoSelected.id;
            }

            if (vm.virtualFairSelected) {
                vm.query['virtual_fair_id'] = vm.virtualFairSelected.id;
            }

            if (vm.semesterSelected && vm.semesterSelected.id != '') {
                vm.query['semester'] = vm.semesterSelected.id;
            }

            if (vm.dueDate.startDate && vm.dueDate.endDate) {
                vm.query['due_date_start']  = moment(vm.dueDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['due_date_end']    = moment(vm.dueDate.endDate).format('YYYY-MM-DD 23:59:59');
            }

            if (vm.dispatchDate.startDate && vm.dispatchDate.endDate) {
                vm.query['dispatch_date_start']  = moment(vm.dispatchDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['dispatch_date_end']    = moment(vm.dispatchDate.endDate).format('YYYY-MM-DD 23:59:59');
            }

            if (vm.invoiceTypesSelected.length > 0) {
                vm.query['types'] = JSON.stringify(vm.invoiceTypesSelected);
            }
            if (vm.invoiceStatusSelected.id > -1) {
                vm.query['status'] = vm.invoiceStatusSelected.id;
            }

            if (vm.companySelected != -1) {
                vm.query['fpp_company'] = vm.companySelected;
            }

            InvoicesService.getInvoicesByFilter(vm.query).then(function(response) {

                vm.invoices = response.data.data;   
                vm.totalItems = response.data.total;
                vm.to = response.data.to;  
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);      

                if ($stateParams.hasOwnProperty('invoice_created') && $stateParams.invoice_created != undefined) {
                    var invoice = $filter('filter')(vm.invoices, {id: $stateParams.invoice_created})[0]; 

                    vm.message = $sce.trustAsHtml('<strong>Success!</strong> Invoice has been sent! <a href="' + invoice.url + '" class="alert-link" target="_Blank">Click here</a> to see the invoice.');
                    vm.classMessage = 'alert-success';
                }

                if ($stateParams.hasOwnProperty('invoice_updated') && $stateParams.invoice_updated != undefined) {
                    var invoice = $filter('filter')(vm.invoices, {id: $stateParams.invoice_updated})[0];                       

                    vm.message = $sce.trustAsHtml('<strong>Success!</strong> Invoice has been updated! <a href="' + invoice.url + '" class="alert-link" target="_Blank">Click here</a> to see the invoice.');
                    vm.classMessage = 'alert-success';
                }

                angular.forEach(vm.invoices, function (invoice) {
                    invoice.has_miscelaneous = false;
                    angular.forEach(invoice.items, function (item) {
                        if (!invoice.has_miscelaneous && item.type=='miscelaneous') {
                            invoice.has_miscelaneous = true;
                        }
                    });
                });

            }).catch(function(err) {
            });
        }     


        function downloadCSV() {
            if (vm.clearFilters == true) {
                vm.query = {};
            }            

            if (vm.name) {
                vm.query['company_name'] = vm.name;
            }

            if (vm.email) {
                vm.query['company_email'] = vm.email;
            }

            if (vm.invoice_id) {
                vm.query['invoice_id'] = vm.invoice_id;
            }

            if (vm.control_id) {
                vm.query['control_id'] = vm.control_id;
            }

            if (vm.sellerSelected) {
                vm.query['seller_id'] = vm.sellerSelected.id;
            }

            if (vm.expoSelected) {
                vm.query['expo_id'] = vm.expoSelected.id;
            }

            if (vm.virtualFairSelected) {
                vm.query['virtual_fair_id'] = vm.virtualFairSelected.id;
            }

            if (vm.semesterSelected && vm.semesterSelected != '') {
                vm.query['semester'] = vm.semesterSelected.id;
            }

            if (vm.dueDate.startDate && vm.dueDate.endDate) {
                vm.query['due_date_start']  = moment(vm.dueDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['due_date_end']    = moment(vm.dueDate.endDate).format('YYYY-MM-DD 23:59:59');
            }

            if (vm.dispatchDate.startDate && vm.dispatchDate.endDate) {
                vm.query['dispatch_date_start']  = moment(vm.dispatchDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['dispatch_date_end']    = moment(vm.dispatchDate.endDate).format('YYYY-MM-DD 23:59:59');
            }

            if (vm.invoiceTypesSelected.length > 0) {
                vm.query['types'] = JSON.stringify(vm.invoiceTypesSelected);
            }

            if (vm.invoiceStatusSelected.id > -1) {
                vm.query['status'] = vm.invoiceStatusSelected.id;
            }

            InvoicesService.downloadCSV(vm.query).then(function(response) {
                var anchor = document.createElement("a");
                
                anchor.href = "data:application/octet-stream;base64," + encodeURI(response.data);
                anchor.target = "_blank";
                anchor.download = `invoices_${moment().format('YYYY-MM-DD')}.csv`;
                document.body.appendChild(anchor);
                anchor.click();
                setTimeout(function () {
                    anchor.remove();
                }, 50);
            }).catch(function(err) {
            });
        }     

        function changeOrder(orderBy) {
            vm.clearFilters = false;

            vm.query['orderBy'] = orderBy;
            vm.page = 1;
            let flag = false;
            vm.getByFilter(flag);

            if (vm.orderByTotal == 'total_asc') {
                vm.orderByTotal = 'total_desc';
            } else if (vm.orderByTotal == 'total_desc') {
                vm.orderByTotal = 'total_asc';
            }
        }         
        
        function loadCompanies () {
            CompaniesService.getAllForSelect().then(function(response) {
                vm.companies = response.data;
                vm.companies.unshift({id: -1, name: '--- All ---'})
            });
        }
    }

})();